/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 26/04/2022
 */

import * as React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import Text from '@/wpt-lib/pdf/common/Text';

const Heading = ({ text, level = 1, center }: { text: string; level?: 1 | 2 | 3; center?: boolean }) => (
    <View style={[styles.heading, styles[`h${level}`]]}>
        <Text
            style={[styles.text, styles[`h${level}Text`], { textAlign: center ? 'center' : 'left' }]}
            minPresenceAhead={1}
        >
            {text}
        </Text>
    </View>
);

const styles = StyleSheet.create({
    heading: {},
    h1: {
        paddingVertical: 10,
    },
    h2: {
        marginTop: 10,
        paddingVertical: 6,
    },
    h3: {
        paddingVertical: 4,
    },
    text: {
        fontWeight: 'bold',
    },
    h1Text: {
        fontSize: 18,
    },
    h2Text: {
        fontSize: 16,
    },
    h3Text: {
        fontSize: 14,
    },
});

export default Heading;
